import { render, staticRenderFns } from "./ImportTimeStudyConstants.vue?vue&type=template&id=4552a040&scoped=true"
import script from "./ImportTimeStudyConstants.vue?vue&type=script&lang=js"
export * from "./ImportTimeStudyConstants.vue?vue&type=script&lang=js"
import style0 from "./ImportTimeStudyConstants.vue?vue&type=style&index=0&id=4552a040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4552a040",
  null
  
)

export default component.exports